<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<!-- This block of code is displayed for unauthorized users -->
<div *ngIf="!authorizedUser">
  <fab-header [appName]="appName"></fab-header>
  <router-outlet></router-outlet>
</div>

<!-- This block of code is displayed for authorized users -->
<div *ngIf="authorizedUser">
  <fab-header [appName]="appName" [navStyle]="'top'">
    <fab-popover-header-action iconName="description" matTooltip="Selected Scenario"
                               *ngIf="!(stateService.selectedScenario === null)">
      <div class="ps-2 pe-2">
        <div *ngIf="stateService.isVehicleScenarioSelected; then vehiclePopover else industryPopover"></div>
        <ng-template #vehiclePopover>
          <div class="d-flex flex-row gap-16 ">
            <div class="scenario-container">
              <div class="p-1">
                <h3>Working Scenario</h3>
                <mat-divider></mat-divider>
              </div>
              <div class="section">
                <span class="label">Forecast Responsibility</span>
                <span class="value">{{ stateService.selectedScenario.fcorg }}</span>
              </div>
              <div class="section">
                <span class="label">Vehicle Scenario</span>
                <span class="value">{{ stateService.selectedScenario.vehScenId }}
                  - {{ stateService.selectedScenario.vehScenName }}</span>
              </div>
              <div class="section">
                <span class="label">Industry Scenario</span>
                <span class="value">{{ stateService.selectedScenario.industryScenario.id }}
                  - {{ stateService.selectedScenario.industryScenario.industryScenarioName }}</span>
              </div>
              <ng-container>
                <div class="section"
                     *ngIf="stateService.selectedScenario?.propulsionScenario.id !== null && stateService.selectedScenario?.propulsionScenario.id !== undefined">
                  <span class="label">Propulsion Scenario</span>
                  <span class="value">{{ stateService.selectedScenario?.propulsionScenario?.id }}
                    - {{ stateService.selectedScenario?.propulsionScenario?.propulsionScenarioName }}</span>
                </div>
              </ng-container>
            </div>

            <div class="scenario-container"
                 *ngIf="stateService.selectedScenario?.vehScenId !== stateService.selectedCompareScenario?.vehScenId">
              <div class="p-1">
                <h3>Compare Scenario</h3>
                <mat-divider></mat-divider>
              </div>
              <div class="section">
                <span class="label">Forecast Responsibility</span>
                <span class="value">{{ stateService.selectedCompareScenario.fcorg }}</span>
              </div>
              <div class="section">
                <span class="label">Vehicle Scenario</span>
                <span class="value">{{ stateService.selectedCompareScenario.vehScenId }}
                  - {{ stateService.selectedCompareScenario.vehScenName }}</span>
              </div>
              <div class="section">
                <span class="label">Industry Scenario</span>
                <span class="value">{{ stateService.selectedCompareScenario.industryScenario.id }}
                  - {{ stateService.selectedCompareScenario.industryScenario.industryScenarioName }}</span>
              </div>
              <ng-container>
                <div class="section"
                     *ngIf="stateService.selectedCompareScenario?.propulsionScenario.id !== null && stateService.selectedCompareScenario?.propulsionScenario.id !== undefined">
                  <span class="label">Propulsion Scenario</span>
                  <span class="value">{{ stateService.selectedCompareScenario?.propulsionScenario?.id }}
                    - {{ stateService.selectedCompareScenario?.propulsionScenario?.propulsionScenarioName }}</span>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-template>

        <ng-template #industryPopover>
          <div class="d-flex flex-column gap-16">
            <div>
              <h3>Working Scenario</h3>
              <mat-divider></mat-divider>
            </div>
            <div class="section">
              <span class="label">Forecast Responsibility</span>
              <span class="value">{{ stateService.selectedScenario.forecastOrganization }}</span>
            </div>
            <div class="section">
              <span class="label">Industry Scenario</span>
              <span class="value">{{ stateService.selectedScenario.id }}
                - {{ stateService.selectedScenario.industryScenarioName }}</span>
            </div>
          </div>
        </ng-template>
      </div>
    </fab-popover-header-action>
    <fab-app-info [appName]="appName"
                  [appVersion]="appVersion"
                  [appVersionCodename]="appVersionCodename"
                  [apiMap]="apiMap"
                  [environmentName]="environmentName"></fab-app-info>
    <fab-popover-header-action iconName="account_circle" matTooltip="User Info">
      <div class="ps-2 pe-2 user-details-divs">
        <div>
          <span class="user-info-label">GMID: </span>{{ user.gmid }}
          <br/>
        </div>
        <div>
          <span class="user-info-label">Name: </span>{{ user.displayName }}
        </div>
        <div>
          <span class="user-info-label">Role: </span>{{ user.role }}
        </div>
        <div>
          <a routerLink="/user-preference" class="settings">
            <mat-icon>settings</mat-icon>
            <span class="ps-2">Preferences</span>
          </a>
        </div>
      </div>
    </fab-popover-header-action>
  </fab-header>
  <fab-topnav [userAuthorities]="userAuthorities">
    <router-outlet></router-outlet>
  </fab-topnav>

</div>

